<div class="container">
  <h1 class="mt120">Certificates</h1>
</div>
<div class="mainContnet">
  <div class="container">
    <p>
      Certificate may be granted for the successful completion of any iTIM
      course. Diplomas are available for the completion of any ministry track
      courses, and a “Degree” for the completion of all courses and their
      practicums.
    </p>
    <button
      type="button"
      class="btn btnPrimary"
      data-toggle="modal"
      data-target="#exampleModalLongsss"
    >
      Create Certificate
    </button>
    <button
      type="button"
      class="btn btnPrimary ml-5"
      data-toggle="modal"
      data-target="#Diplomamodel"
    >
      Create Diploma
    </button>

    <div
      class="container"
      id="contentToConvert"
      style="position: absolute; left: -999em"
    >
      <div class="container mt120 mb-5 border border-success">
        <div class="container mt120 mb-5 pt-50 pb-50">
          <h1 class="text-center">INSTITUTE FOR TRAINING IN MINISTRY</h1>
          <p class="text-center mt50 mx-auto">
            This certifies that {{ userForm.controls.firstname.value }}
            {{ userForm.controls.lastname.value }} has successfully completed
            the {{ getCourseNameByKey(userForm.controls.course?.value) }} track
            course {{ userForm.controls.course?.value?.toUpperCase() }} and is
            hereby authorized to lead others through this course.
          </p>
          <div class="ftr mt120 mx-auto w-100">
            <div class="logo mx-auto text-center w-50 d-inline-block">
              <img
                src="../../../../assets/images/iTIMlogo.jpeg"
                height="150"
                alt="LOGO"
              />
            </div>
            <div class="code text-center d-inline-block w-50">
              <img
                src="../../../assets/images/Bob-Signature.jpg"
                height="50"
                alt="SIGNATURE"
              />
              <p class="">
                Dr. Robert Samms <br />
                Dean, Institute for Training in Ministry
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      class="container"
      id="contentToConvert1"
      style="position: absolute; left: -999em"
    >
      <div
        class="container mt120 mb-5 border border-success"
        id="contentToConvert"
      >
        <div class="container mt120 mb-5 pt-50 pb-50">
          <h1 class="mt120 text-center">INSTITUTE FOR TRAINING IN MINISTRY</h1>
          <h2 class="mt-3 text-center">DIPLOMA</h2>
          <p class="text-center mt50 mx-auto">
            This diploma is awarded to {{ userForm.controls.firstname.value }}
            {{ userForm.controls.lastname.value }} for completing the
            {{ userForm.controls.course?.value?.toUpperCase() }} Track and is
            hereby authorized to lead others through this track of courses.
          </p>
          <div class="ftr mt120 mx-auto w-100">
            <div class="logo mx-auto text-center w-50 d-inline-block">
              <img
                src="../../../../assets/images/iTIMlogo.jpeg"
                height="150"
                alt="LOGO"
              />
            </div>
            <div class="code text-center d-inline-block w-50">
              <img
                src="../../../assets/images/Bob-Signature.jpg"
                height="50"
                alt="SIGNATURE"
              />
              <p class="">
                Dr. Robert Samms <br />
                Dean, Institute for Training in Ministry
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <app-static-footer></app-static-footer>
</div>

<div
  class="modal fade"
  id="exampleModalLongsss"
  tabindex="-1"
  role="dialog"
  aria-labelledby="exampleModalLongTitle"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header border-0 py-0 pt-0">
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <form [formGroup]="userForm">
          <div class="modal-body">
            <div class="form-group">
              <label class="fontBlk">Firstname</label>
              <input
                type="text"
                class="form-control input"
                formControlName="firstname"
                [class.is-invalid]="isControlInvalid('firstname')"
                [class.is-valid]="isControlValid('firstname')"
              />
              <h5
                class="invalid-feedback"
                *ngIf="controlHasError('required', 'firstname')"
              >
                This field is required
              </h5>
            </div>

            <div class="form-group">
              <label class="fontBlk">Last Name</label>
              <input
                type="text"
                class="form-control input"
                formControlName="lastname"
                [class.is-invalid]="isControlInvalid('lastname')"
                [class.is-valid]="isControlValid('lastname')"
              />
              <h5
                class="invalid-feedback"
                *ngIf="controlHasError('required', 'lastname')"
              >
                This field is required
              </h5>
            </div>

            <div class="form-group">
              <label class="fontBlk">Course</label>
              <select
                style="height: 45px"
                name="cars"
                id="cars"
                class="form-control input"
                formControlName="course"
                [class.is-invalid]="isControlInvalid('course')"
                [class.is-valid]="isControlValid('course')"
              >
                <option
                  *ngFor="let item of getCourseArray"
                  value="{{ item.key }}"
                >
                  {{ item.value }}
                </option>
              </select>

              <h5
                class="invalid-feedback"
                *ngIf="controlHasError('required', 'course')"
              >
                This field is required
              </h5>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btnWhite"
              data-dismiss="modal"
              (click)="closeModel()"
            >
              Cancel
            </button>
            <button
              type="submit"
              class="btn btnPrimary"
              data-dismiss="modal"
              aria-label="Close"
              (click)="DownloadCertificate()"
            >
              Download
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>

<div
  class="modal fade"
  id="Diplomamodel"
  tabindex="-1"
  role="dialog"
  aria-labelledby="exampleModalLongTitle"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header border-0 py-0 pt-0">
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <form [formGroup]="userForm">
          <div class="modal-body">
            <div class="form-group">
              <label class="fontBlk">Firstname</label>
              <input
                type="text"
                class="form-control input"
                formControlName="firstname"
                [class.is-invalid]="isControlInvalid('firstname')"
                [class.is-valid]="isControlValid('firstname')"
              />
              <h5
                class="invalid-feedback"
                *ngIf="controlHasError('required', 'firstname')"
              >
                This field is required
              </h5>
            </div>

            <div class="form-group">
              <label class="fontBlk">Last Name</label>
              <input
                type="text"
                class="form-control input"
                formControlName="lastname"
                [class.is-invalid]="isControlInvalid('lastname')"
                [class.is-valid]="isControlValid('lastname')"
              />
              <h5
                class="invalid-feedback"
                *ngIf="controlHasError('required', 'lastname')"
              >
                This field is required
              </h5>
            </div>

            <div class="form-group">
              <label class="fontBlk">Tracks</label>
              <select
                style="height: 45px"
                name="cars"
                id="cars"
                class="form-control input"
                formControlName="course"
                [class.is-invalid]="isControlInvalid('course')"
                [class.is-valid]="isControlValid('course')"
              >
                <option
                  *ngFor="let item of getDiplomaCourse"
                  value="{{ item.key }}"
                >
                  {{ item.value }}
                </option>
              </select>

              <h5
                class="invalid-feedback"
                *ngIf="controlHasError('required', 'course')"
              >
                This field is required
              </h5>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btnWhite"
              data-dismiss="modal"
              (click)="closeModel()"
            >
              Cancel
            </button>
            <button
              type="submit"
              class="btn btnPrimary"
              data-dismiss="modal"
              aria-label="Close"
              (click)="DownloadDiplomaCertificate()"
            >
              Download
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
